import actionTypes from '../actionTypes';

const initialState = {
    capabilities: null,
    originalFlags: null,
    currentFlags: null,
    isLoading: true,
    loadError:  false,
    saveError: false,
    saveSuccess: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESTAURANT_CAPABILITIES_LOADING:
            return {
                ...state,
                isLoading: true,
                loadError:  false
            };
        case actionTypes.RESTAURANT_CAPABILITIES_LOADED:
            return {
                ...state,
                isLoading: false,
                loadError:  false
            };
        case actionTypes.RESTAURANT_CAPABILITIES_ERROR:
            return {
                ...state,
                isLoading: false,
                loadError:  true
            };
        case actionTypes.RESTAURANT_ALL_CAPABILITIES_LOADED:
            return {
                ...state,
                capabilities: action.payload
            };
        case actionTypes.RESTAURANT_FLAGS_LOADED:
            console.warn(action.payload);
            return {
                ...state,
                currentFlags: action.payload,
                originalFlags: action.payload
            };
        case actionTypes.RESTAURANT_CAPABILITIES_SET_FLAG:
            return {
                ...state,
                currentFlags: {
                    ...state.currentFlags,
                    [action.payload.id]: action.payload.value
                },
                hasChanges: true
            };
        case actionTypes.RESTAURANT_CAPABILITIES_RESET_FLAGS:
            return {
                ...state,
                currentFlags: state.originalFlags,
                hasChanges: false
            };
        case actionTypes.RESTAURANT_CAPABILITIES_SAVING:
            return {
                ...state,
                hasChanges: false,
                saveError: false
            };
        case actionTypes.RESTAURANT_CAPABILITIES_SAVED:
            return {
                ...state,
                saveSuccess: true
            };
        case actionTypes.RESTAURANT_CAPABILITIES_SAVED_CLEAR:
            return {
                ...state,
                saveSuccess: false
            };
        case actionTypes.RESTAURANT_CAPABILITIES_SAVE_ERROR:
            return {
                ...state,
                saveError: true,
                hasChanges: true
            };
        case actionTypes.RESTAURANT_CAPABILITIES_CLEAR_ERRORS:
            return {
                ...state,
                saveError: false,
                loadError: false
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// /src/store/reducers/capabilities.js